export default __webpack_public_path__ + "static/media/payu.7efca29a.jpg";